import styled from 'styled-components';

import Widget from '~/src/components/Widget';

export const ImageBlock = styled(Widget.ImageBlock)`
    picture {
        max-width: 70px;
        height: auto;
        margin: auto;
    }
`;
